import { useEffect, useState } from 'react'
import { getDevChromeEngine, setDevChromeEngine } from '../api'
import { IS_BOOSTER_ONLY, IS_PROFILER_ONLY } from '../product'

// DEV-only Chrome engine picker (147 vs 152), shown at the bottom of the sidebar.
// Renders NOTHING unless the backend reports availability (BB_INTERNAL dev panel
// AND the 152 binary present on disk) — so it never appears on client panels.
// Switching affects only NEW worker launches; the 147 build is never touched.
export default function DevEngineSwitcher({ collapsed }: { collapsed?: boolean }) {
  const [avail, setAvail] = useState(false)
  const [engine, setEngine] = useState<'147' | '152'>('147')
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    if (IS_BOOSTER_ONLY || IS_PROFILER_ONLY) return
    getDevChromeEngine()
      .then((r) => {
        if (r && r.available) {
          setAvail(true)
          setEngine(r.engine === '152' ? '152' : '147')
        }
      })
      .catch(() => {})
  }, [])

  if (collapsed || !avail) return null

  const pick = async (e: '147' | '152') => {
    if (busy || e === engine) return
    const prev = engine
    setBusy(true)
    setEngine(e)
    try {
      const r = await setDevChromeEngine(e)
      if (r && r.error) setEngine(prev)
    } catch {
      setEngine(prev)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="px-4 py-2 border-t border-sidebar-border">
      <div className="text-[10px] uppercase tracking-wider text-amber-500/70 font-semibold mb-1">
        DEV · движок Chrome
      </div>
      <div className="flex gap-1">
        {(['147', '152'] as const).map((e) => (
          <button
            key={e}
            disabled={busy}
            onClick={() => pick(e)}
            title={e === '152' ? 'Новая сборка Chromium 152 (тест)' : 'Рабочая сборка Chromium 147'}
            className={`flex-1 h-7 rounded text-xs font-medium transition-colors disabled:opacity-60 ${
              engine === e
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted/40 text-muted-foreground hover:bg-muted'
            }`}
          >
            {e === '152' ? '152 ·new' : '147'}
          </button>
        ))}
      </div>
      <div className="text-[10px] text-muted-foreground/50 mt-1">действует на новые запуски потоков</div>
    </div>
  )
}
